import type React from 'react';

import { Spacer } from '@zillow/constellation';

import YesAndNo from './YesAndNo';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
};

export default function YesAndNoExpansion({ yesHandler, noHandler, yesActive, className, children, disabled }: Props) {
  function renderChildren(): React.ReactNode {
    return yesActive && <Spacer marginTop="sm">{children}</Spacer>;
  }

  return (
    <>
      <YesAndNo
        className={className}
        yesHandler={yesHandler}
        noHandler={noHandler}
        yesActive={yesActive}
        disabled={disabled}
      />
      {renderChildren()}
    </>
  );
}
